// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildDefect,
  BuildDefectFromJSON,
  BuildDefectToJSON,
  BuildRiskCoverage,
  BuildRiskCoverageFromJSON,
  BuildRiskCoverageToJSON,
  BuildTestPlanResult,
  BuildTestPlanResultFromJSON,
  BuildTestPlanResultToJSON,
  BuildTraceabilityDefectSummary,
  BuildTraceabilityDefectSummaryFromJSON,
  BuildTraceabilityDefectSummaryToJSON,
  BuildTraceabilityResults,
  BuildTraceabilityResultsFromJSON,
  BuildTraceabilityResultsToJSON,
  BuildWorkItem,
  BuildWorkItemFromJSON,
  BuildWorkItemToJSON,
} from "./";

/**
 * Aggregated traceability for a build (TCV-6726). Provider-neutral: the same shape is returned whether the project is connected to Azure DevOps or managed manually; the client decides which sections to surface.
 * @export
 * @interface BuildTraceability
 */
export interface BuildTraceability {
  /**
   *
   * @type {BuildTraceabilityResults}
   * @memberof BuildTraceability
   */
  results: BuildTraceabilityResults;
  /**
   * Test plans linked to this build, each with its cached result distribution.
   * @type {Array<BuildTestPlanResult>}
   * @memberof BuildTraceability
   */
  testPlans: Array<BuildTestPlanResult>;
  /**
   *
   * @type {BuildRiskCoverage}
   * @memberof BuildTraceability
   */
  riskCoverage: BuildRiskCoverage;
  /**
   * Defects raised against the build's test plans (built-in issue tracker or connected manager).
   * @type {Array<BuildDefect>}
   * @memberof BuildTraceability
   */
  defects: Array<BuildDefect>;
  /**
   *
   * @type {BuildTraceabilityDefectSummary}
   * @memberof BuildTraceability
   */
  defectSummary: BuildTraceabilityDefectSummary;
  /**
   * External work items exercised by test cases executed in this build.
   * @type {Array<BuildWorkItem>}
   * @memberof BuildTraceability
   */
  workItems: Array<BuildWorkItem>;
}

export function BuildTraceabilityFromJSON(json: any): BuildTraceability {
  return {
    results: BuildTraceabilityResultsFromJSON(json["results"]),
    testPlans: (json["test_plans"] as Array<any>).map(
      BuildTestPlanResultFromJSON
    ),
    riskCoverage: BuildRiskCoverageFromJSON(json["risk_coverage"]),
    defects: (json["defects"] as Array<any>).map(BuildDefectFromJSON),
    defectSummary: BuildTraceabilityDefectSummaryFromJSON(
      json["defect_summary"]
    ),
    workItems: (json["work_items"] as Array<any>).map(BuildWorkItemFromJSON),
  };
}

export function BuildTraceabilityToJSON(value?: BuildTraceability): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    results: BuildTraceabilityResultsToJSON(value.results),
    test_plans: (value.testPlans as Array<any>).map(BuildTestPlanResultToJSON),
    risk_coverage: BuildRiskCoverageToJSON(value.riskCoverage),
    defects: (value.defects as Array<any>).map(BuildDefectToJSON),
    defect_summary: BuildTraceabilityDefectSummaryToJSON(value.defectSummary),
    work_items: (value.workItems as Array<any>).map(BuildWorkItemToJSON),
  };
}
